import { render, staticRenderFns } from "./RequestAccess.vue?vue&type=template&id=20babf3b"
import script from "./RequestAccess.vue?vue&type=script&lang=js"
export * from "./RequestAccess.vue?vue&type=script&lang=js"
import style0 from "./RequestAccess.vue?vue&type=style&index=0&id=20babf3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports